import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    content: 'mx-auto flex w-full max-w-[400px] flex-col gap-[32px]',
    tab: 'h-10 w-1/2 normal-case',
    modalHead: 'flex flex-col gap-[8px]',
    title: 'heading-2xl lg:heading-3xl leading-[120%] font-semibold',
    subtitle: 'lg:text-m font-regular trading-[0,02] text-xs leading-[140%]',
    modalContent: '',
    informer:
      'text-s pointer-events-auto! translate-y-0! cursor-pointer! leading-[140%] font-semibold text-black opacity-100!',
    informerSmall: 'text-xs'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
